import { Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { DrawerRef } from './drawer-ref';

export interface DrawerAction<T> {
  label: string;
  action: (component: T) => void;
  buttonClass?: string;
  validation?: (component: T) => boolean;
}
export interface DrawerConfig<T = any, D = any> {
  component: Type<T>;
  data?: D;
  width?: string;
  classDrawer?: string;
  title?: string;
  actions?: DrawerAction<T>[];
  classes?: string;
  drawerRef?: DrawerRef;
}

@Injectable({
  providedIn: 'root'
})
export class DrawerService {
  private drawerSubject = new Subject<DrawerConfig | null>();
  drawer$ = this.drawerSubject.asObservable();

  open<T>(config: DrawerConfig<T>): DrawerRef {
    const drawerRef = new DrawerRef();
    this.drawerSubject.next({ ...config, drawerRef });

    return drawerRef;
  }

  close() {
    this.drawerSubject.next(null);
  }

}
